import { render, staticRenderFns } from "./process-image.vue?vue&type=template&id=6596c981&scoped=true"
import script from "./process-image.vue?vue&type=script&lang=js"
export * from "./process-image.vue?vue&type=script&lang=js"
import style0 from "./process-image.vue?vue&type=style&index=0&id=6596c981&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6596c981",
  null
  
)

export default component.exports